import {
    Box,
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    Heading,
    HStack, Link as ChakraLink,
    Stack,
    StackDivider,
    Text
} from '@chakra-ui/react';

import {Link, useNavigate} from 'react-router-dom';
import RegistrationStateBadge from '../../parts/RegistrationStateBadge';
import {ChevronLeftIcon} from '@chakra-ui/icons';
import {RegistrationStateText, RegistrationStateType, RequestTypeText} from '../../../model/census';
import React, {FormEvent, useEffect, useRef, useState} from 'react';
import {useApiProvider} from '../../../api/ApiProvider';
import ErrorMessage from '../../parts/ErrorMessage';
import LoadingWidget from "../../parts/LoadingWidget";
import {CensusByIdForLeaderDTO} from "../../../model/censusForLeaderDTO";
import RequestStateBadge from "../../parts/RequestStateBadge";
import {censusByIdForLeaderDTOTranslateKey} from "../../../utils/CensusByIdForLeaderDTOTranslateKey";
import {InstructorRank} from "../../../model/scout";
import AssignmetsRender from "../../parts/AssignmetsRender";
import {Assignment} from "../../../model/assignment";
import Option from "../../../interfaces/Option";
import InputRef from "../../../interfaces/InputRef";
import InputSelectRef from "../../../interfaces/InputSelectRef";
import InputSelect from "../../parts/InputSelect";
import InputText from "../../parts/InputText";
import RequiredMark from "../../parts/RequiredMark";
import ButtonSubmit from "../../parts/ButtonSubmit";
import InputRequiredRef from "../../../interfaces/InputRef";

function CensusRender({ registrantId }: {registrantId: string}) {
    const navigate = useNavigate();
    const provider = useApiProvider();

    const [census, setCensus] = useState<CensusByIdForLeaderDTO | undefined>(undefined);
    const [isFetched, setIsFetched] = useState<boolean>(false);
    const [fetchErr, setFetchErr] = useState<string>("");
    const [openForm, setOpenForm] = useState<boolean>(false);

    const stateOptions : Option[] = [
        { label: 'wpisz na listę', value: 'Registered' },
        { label: 'wstrzymaj decyzję', value: 'Suspended' },
    ];

    const [selectedStateOption, setSelectedStateOption] = useState<Option | undefined>(undefined);
    const stateRef = useRef<InputSelectRef>();
    const commentRef = useRef<InputRequiredRef>();
    const [submittingError, setSubmittingError] = useState<string>("");
    const [submitting, setSubmitting] = useState<boolean>(false);

    useEffect(() => {
        provider.getLeaderCensus(registrantId)
            .then(data => setCensus(data))
            .catch(err => setFetchErr("Nie udało się pobrać danych instruktora"))
            .finally(() => setIsFetched(true));
      }, []);

    const handleSubmit = (e: FormEvent) => {
        e.preventDefault();

        if (stateRef.current?.validate()) {
            setSubmitting(true);
            setSubmittingError("");

            console.log("census?.CensusId!: " + census?.CensusId!)
            provider.updateCensusState({
                id: census?.CensusId!,
                sendingLeaderId: '',
                state: selectedStateOption!.value,
                content: commentRef.current?.value() ?? ''
            })
                .then(census => navigate("/censuses"))
                .catch(err => setSubmittingError(err))
                .finally(() => setSubmitting(false));
        }

    };
    
    if (isFetched)
    {
        return (
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                height="100%"
                width="100%"
                pt="89px"
            >
                <Box
                    width="500px"
                    pt="55px"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Link to={`..`}><ChevronLeftIcon /> Wróć do wszystkich spisów</Link>
                    <Card
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        shadow="none"
                        padding="13px"
                        width="100%"
                        maxWidth="500px"
                    >
                        <CardHeader>
                            <Heading size='md'>
                                {`${InstructorRank[census!.InstructorRank!].toLowerCase()} ${census?.Name} ${census?.Surname}`}
                            </Heading>
                        </CardHeader>
                        <CardBody width="100%">
                            <Stack divider={<StackDivider />} spacing="4">
                                {census == null ? null : Object.entries(census)
                                    .filter(([key, value]) => value !== "" && value !== null)
                                    .filter(([key, value]) => !['Name', 'Surname', 'InstructorRank', 'Assignments'].includes(key))
                                    .map(([key, value]) => (
                                        <Box key={key}>
                                            <Heading size="xs" textTransform="uppercase">
                                                {censusByIdForLeaderDTOTranslateKey[key]}
                                            </Heading>
                                            <HStack>
                                                {key === 'Request' ? (
                                                        <RequestStateBadge marginTop={2} requestState={RequestTypeText[value]} />
                                                    ) : key === 'RegistrationState' ? (
                                                        <RegistrationStateBadge marginTop={2} registrationState={RegistrationStateText[value]} />
                                                    ) : key === 'InstructorRank' ? (
                                                        <Text pt="2" fontSize="sm">{InstructorRank[value].toLowerCase()}</Text>
                                                    ) : typeof value === "object" ? (
                                                        <Text pt="2" fontSize="sm">{JSON.stringify(value, null, 2)}</Text>
                                                    ) : typeof value === "boolean" ? (
                                                        <Text pt="2" fontSize="sm">{value ? "zaakceptowano" : "niezaakceptowano"}</Text>
                                                    ) : ['VacationStartDate', 'VacationEndDate', 'KRKIssueDate', 'CreateDate'].includes(key) ? (
                                                        <Text pt="2" fontSize="sm">{value.toString().split('T')[0]}</Text>
                                                    ) : (
                                                        <Text pt="2" fontSize="sm">{value}</Text>
                                                    )}
                                            </HStack>
                                        </Box>
                                    ))}
                            </Stack>
                        </CardBody>
                        <AssignmetsRender assignments={census?.Assignments! as Assignment[]}/>
                        {census?.RegistrationState == RegistrationStateType.InProcess ?
                            openForm ?
                                    <form onSubmit={handleSubmit} style={{
                                        width: '100%'
                                    }}>
                                        <Box
                                            padding="3"
                                            display="flex"
                                            flexDirection="column"
                                            height="80%"
                                        >
                                            <InputSelect
                                                ref={stateRef}
                                                initValue={undefined}
                                                label={'Stan wniosku'}
                                                placeholderText={'Wpisz jaki stan ustawiasz:'}
                                                options={stateOptions}
                                                isRequired={true}
                                                getSelectedOption={setSelectedStateOption}
                                            />
                                            <Box my="21"></Box>
                                            <InputText
                                                ref={commentRef}
                                                label={'Dodatkowe uwagi'}
                                                placeholderText={'miejsce na twoje dodatkowe uwagi'}
                                                isRequired={false}
                                                rows={3}
                                                maxLength={500}
                                            />
                                            <RequiredMark withDescription/>
                                            <ErrorMessage text={submittingError}/>
                                            <ButtonSubmit isSubmitting={submitting} text={'Zmień stan rejestracji w bazie'}/>
                                        </Box>
                                    </form> :
                                    <CardFooter
                                        display="flex"
                                        justifyContent="left"
                                        flexDirection="column"
                                        alignItems="center"
                                        shadow="none"
                                        width="100%"
                                        maxWidth="500px"
                                    >
                                        <ChakraLink onClick={() => setOpenForm(true)}
                                                    px="5"
                                                    py="2"
                                                    rounded="md"
                                                    color="white"
                                                    bg="green.500"
                                                    fontWeight="bold"
                                                    _hover={{
                                                        textDecoration: "none",
                                                        bg: "brand.700"
                                                    }}
                                        >
                                            Potwierdź rejestrację
                                        </ChakraLink>
                                    </CardFooter>
                        :
                        <></>}
                    </Card>
                </Box>
            </Box>
        );
    } else {
        return (
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                height="100%"
                width="100%"
                pt="89px"
            >
                <Box
                    width="500px"
                    pt="55px"
                >
                <Link to={`..`}><ChevronLeftIcon /> Wróć do wszystkich spisów</Link>
                <Box
                    bg="white"
                    mt="89px"
                    padding="5"
                    borderRadius="md"
                    textAlign="center"
                    width="2xl"
                    height="80%"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    flexDirection="column"
                >
                    {fetchErr ? (
                        <>
                            <ErrorMessage text={fetchErr} />
                        </>
                    ) : <LoadingWidget withImage={false}/>}
                    
                </Box>
            </Box>
        </Box>
        )
    }
    
}

export default CensusRender;